import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Select from "react-select";

//components***********
import Navbar from "../../Components/Navbar/Navbar";
import { Form, Tab, Tabs, Row, Col } from "react-bootstrap";
import Table from "../../Components/TableTemplate/Table";
import {
  refreshPage,
  toastStyle,
  TokenExpiry,
  getTime,
  selectDropdownStyle,
  getType,
  getBranchId,
} from "../../Helpers/Utils/Common";
import RequestModal from "./Requests/RequestModal";
import ApproveRequestModal from "./Requests/ApproveRequestModal";

//api***********
import {
  getAllRequests,
  deleteRequest,
} from "../../Helpers/apiCalls/Inventory/RequestsApi";
import { getAllBranches } from "../../Helpers/apiCalls/Purchases/purchaseOrderApi";

//css***********
import "./Inventory.css";
import "../../Components/Navbar/Navbar.css";
import Moment from "moment";
import Footer from "../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination";

export default function Requests() {
  //****VARIABLES****//
  let navigate = useNavigate();
  const accountType = getType();
  const [inactive, setInactive] = useState(false);
  const [requestManager, setRequestManager] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const today = new Date();
  const sevendaysago = new Date();
  sevendaysago.setDate(sevendaysago.getDate() - 7);

  const [filterConfig, setFilterConfig] = useState({
    tab: "pending",
    requester_id: "",
    date_from: "",
    date_to: "",
    shop: "",
    branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    page: 1
  });
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Change this based on your requirement

  const handlePageChange = page => {
    setCurrentPage(page);
    setFilterConfig(prev => ({
      ...prev,
      page: page,
    }));
  };

  function handleBranchChange(e) {
    //
    const toFilter = { target: { name: "branch_from", value: e.value } };
    handleFilterChange(toFilter);
  }

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false);
  const handleShowApproveModal = () => setShowApproveModal(true);
  const handleCloseApproveModal = () => setShowApproveModal(false);

  /* Disapprove Modal */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false);
  const handleShowDisapproveModal = () => setShowDisapproveModal(true);
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false);

  /* Delete Modal */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    if (tabKey !== "all") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          shop: "",
          date_from: "",
          date_to: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          page: 1
        };
      });
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          shop: "",
          date_from: sevendaysago,
          date_to: today,
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          page: 1
        };
      });
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  async function handleSelectChange(e, id, row) {
    setSelectedRow(row);

    switch (e.target.value) {
      case "reject":
        handleShowDisapproveModal();
        break;

      case "delete":
        handleShowDeleteModal();
        break;

      case "print":
        navigate("/requests/view/" + row.doc_no + "/" + row.status);
        break;

      case "create":
        handleShowApproveModal();
        break;

      case "view":
        navigate("/requests/view/" + row.doc_no + "/" + row.status);
        break;

      case "edit":
        navigate("/requests/edit/" + row.doc_no);
        break;
      default:
        break;
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row.id, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        <option value="view" className="color-options">
          View
        </option>
        <option value="edit" className="color-options">
          Edit
        </option>
        {type !== "pending" && (
          <option value="print" className="color-options">
            Print
          </option>
        )}
        {type === "pending" && (
          <>
            <option value="create" className="color-options">
              Create Transfer
            </option>
            <option value="reject" className="color-red">
              Reject
            </option>
          </>
        )}
        <option value="delete" className="color-red">
          Delete
        </option>
      </Form.Select>
    );
  }

  function ReviewAction(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleReviewAction(row, row.id, row.status)}
      >
        Review
      </button>
    );
  }

  async function handleReviewAction(row, id, status) {
    navigate("/requests/view/" + row.doc_no + "/" + status);
  }

  function ViewAction(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleViewAction(row, row.id, row.status)}
      >
        View
      </button>
    );
  }

  async function handleViewAction(row, id, status) {
    navigate("/requests/view/" + row.doc_no + "/" + status);
  }

  function redirectToTransfer() {
    navigate("/transfers/add/" + selectedRow.id);
  }

  //****API CALLS****
  async function fetchBranches() {
    setShowLoader(true);
    setBranches([]);

    const response = await getAllBranches();

    var branches = response.data.data.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    ).map((branch) => {
      var info = branch;
      info.label= branch.name
      info.value= branch.id
      return info
    });
    if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
        var filteredBranch = branches.filter((data) => {
        return data.id === getBranchId()
        })
        setBranches(filteredBranch);
    } else {
        setBranches([{label: "All Branches", value:""}, ...branches]);
    }
    setShowLoader(false);
  }

  async function fetchRequests() {
    setShowLoader(true);
    setRequestManager([]);
    setTotalItems(0)

    const response = await getAllRequests(filterConfig);

    if (response.data) {
      setRequestManager([]);
      var sortedData = response.data.data.sort((a, b) =>
        a.request_date > b.request_date
          ? 1
          : b.request_date > a.request_date
          ? -1
          : 0
      );
      sortedData.reverse().map((req) => {
        var stat = req.status.split("_");
        var info = req;
        info.doc_no = req.id;
        info.shopType = "";
        info.status = stat.length < 2 ? req.status : stat[0] + " " + stat[1];
        info.request_date =
          req.request_date !== "0000-00-00"
            ? Moment(req.request_date).format("MMM DD, YYYY")
            : "";
        info.delivery_date =
          req.delivery_date !== "0000-00-00"
            ? Moment(req.delivery_date).format("MMM DD, YYYY")
            : "";
        info.received_date = req.completed_on
          ? Moment(req.completed_on).format("MMM DD, YYYY")
          : "N/A";
        info.rqt_time = getTime(req.added_on);
        info.approve_time = getTime(req.approved_on);
        setRequestManager((prev) => [...prev, info]);
      });
      setTotalItems(response.data.size);
    }
    setShowLoader(false);
  }

  async function deleteRequestMod() {
    const response = await deleteRequest(selectedRow.id);
    if (response.data) {
      toast.success("Successfully deleted request!", {
        style: toastStyle(),
      });
      setTimeout(() => refreshPage(), 1000);
    } else if (response.error) {
      TokenExpiry(response);
      toast.error("Something went wrong", { style: toastStyle() });
      setTimeout(() => refreshPage(), 1000);
    }
  }

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchRequests();
  }, [filterConfig, currentPage]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> REQUESTS </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="branch_to_name"
                placeholder="Search Request To..."
                className="search-bar"
                onKeyPress={(e) =>
                  e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
                }
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
                <button
                  className="add-btn"
                  onClick={() => navigate("/requests/add")}
                >
                  Add
                </button>
              </div>
          </Col>
      </Row>
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="for_approval" title="For Approval">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder={"All Branches"}
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchChange}
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date From"}
                selected={filterConfig.date_from}
                name="date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_from: date,
                    };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date To"}
                selected={filterConfig.date_to}
                name="date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_to: date,
                    };
                  });
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE REQUESTED",
                "DOC NO.",
                "DELIVERY DATE",
                "REQUEST FROM",
                "REQUEST TO",
                "STATUS",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "request_date",
                "id",
                "delivery_date",
                "branch_from_name",
                "branch_to_name",
                "status",
              ]}
              tableData={requestManager}
              ActionBtn={(row) => ActionBtn(row, "for_approval")}
              ViewBtn={(row) => ReviewAction(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="pending" title="Pending">
          <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder={"All Branches"}
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchChange}
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date From"}
                selected={filterConfig.date_from}
                name="date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_from: date,
                    };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date To"}
                selected={filterConfig.date_to}
                name="date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_to: date,
                    };
                  });
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE REQUESTED",
                "DOC NO.",
                "DELIVERY DATE",
                "APPROVED BY",
                "REQUEST FROM",
                "REQUEST TO",
                "STATUS",
                "RQT TIME",
                "APPRVE TIME",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "request_date",
                "id",
                "delivery_date",
                "approved_by_name",
                "branch_from_name",
                "branch_to_name",
                "status",
                "rqt_time",
                "approve_time",
              ]}
              tableData={requestManager}
              ActionBtn={(row) => ActionBtn(row, "pending")}
              ViewBtn={(row) => ReviewAction(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="processing" title="Processed">
          <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder={"All Branches"}
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchChange}
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date From"}
                selected={filterConfig.date_from}
                name="date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_from: date,
                    };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date To"}
                selected={filterConfig.date_to}
                name="date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_to: date,
                    };
                  });
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE REQUESTED",
                "DOC NO.",
                "DELIVERY DATE",
                // "DATE RECEIVED",
                "ENCODED BY",
                "REQUEST FROM",
                "REQUEST TO",
                "STATUS",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "request_date",
                "id",
                "delivery_date",
                // "received_date",
                "encoded_by_name",
                "branch_from_name",
                "branch_to_name",
                "status",
              ]}
              tableData={requestManager}
              ActionBtn={(row) => ActionBtn(row, "processed")}
              ViewBtn={(row) => ViewAction(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="completed" title="completed" className="manager-tabs">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder={"All Branches"}
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchChange}
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date From"}
                selected={filterConfig.date_from}
                name="date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_from: date,
                    };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                placeholderText={"Select Date To"}
                selected={filterConfig.date_to}
                name="date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      date_to: date,
                    };
                  });
                }}
                minDate={filterConfig.date_from}
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE REQUESTED",
                "DOC NO.",
                "DELIVERY DATE",
                "DATE RECEIVED",
                "ENCODED BY",
                "REQUEST FROM",
                "REQUEST TO",
                "STATUS",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "request_date",
                "id",
                "delivery_date",
                "received_date",
                "encoded_by_name",
                "branch_from_name",
                "branch_to_name",
                "status",
              ]}
              tableData={requestManager}
              ActionBtn={(row) => ActionBtn(row, "completed")}
              ViewBtn={(row) => ViewAction(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
      </div>
      <ApproveRequestModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="create transfer"
        handler={redirectToTransfer}
      />
      <RequestModal
        show={showDisapproveModal}
        hide={handleCloseDisapproveModal}
        type="reject"
        selectedRow={selectedRow}
        page={"table"}
      />
      <ApproveRequestModal
        show={showDeleteModal}
        hide={handleCloseDeleteModal}
        type="delete"
        handler={deleteRequestMod}
      />
      <Footer/>
    </div>
  );
}
